import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styleUrls: ['./page404.component.scss'],
    imports: [
        MatButtonModule, 
        MatIconModule,
        TranslatePipe,
    ],
})
export class Page404Component {
    private readonly _router = inject(Router);
    private readonly _location = inject(Location);

    constructor() {}

    submit(e: Event) {
        this._router.navigate(['/']);
        e.preventDefault();
    }
    
    goBack(e: Event) {
        this._location.back();
        e.preventDefault();
    }
}
